import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Modal from './Modal';

const CareerOption = ({ filterData }) => {
  const [modal, setModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [data, setData] = useState([]);
  const [mobileView, setMobileView] = useState(false);

  const handleResize = () => {
    setMobileView(window.innerWidth <= 1008);
  };

  const fetchData = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/careerPost`);
      setData(res.data);
    } catch (err) {
      console.error('Error fetching career posts:', err);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    fetchData();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (filterData.length > 0) setData(filterData);
  }, [filterData]);

  const openModal = (id) => {
    setSelectedId(id);
    setModal(true);
  };

  const onClose = () => {
    setModal(false);
    setSelectedId(null);
    fetchData();
  };

  const deletePost = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/careerPost/${id}`);
      fetchData();
    } catch (error) {
      console.error('Error deleting post:', error);
    }
  };

  return (
    <div className="relative overflow-x-auto shadow-md sm:rounded-lg *:font-sans">
      <table className="w-[83vw] text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 ml-[8vw] md:ml-0">
        <thead className={`text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ${mobileView ? 'pl-[5vw] flex w-[80vw]' : ''}`}>
          <tr>
            <th className="px-3 py-3">Job</th>
            <th className="px-3 py-3">Description</th>
            <th className="px-3 py-3">Type</th>
            <th className="px-3 py-3">Experience</th>
            <th className="px-3 py-3">Skills</th>
            <th className="px-3 py-3">Qualification</th>
            <th className="px-3 py-3">Location</th>
            <th className="px-3 py-3">Operations</th>
          </tr>
        </thead>
        <tbody>
          {data.map((post, index) => (
            <tr
              key={post.id}
              className={`${index % 2 === 0 ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'} border-b dark:border-gray-700 ${mobileView ? 'ml-[5vw] flex flex-col' : ''}`}
            >
              <td className="px-3 py-2">{post.job}</td>
              <td className="px-3 py-2">
                {post.description
                  ? post.description.length > 30
                    ? post.description.slice(0, 30) + '...'
                    : post.description
                  : 'No description'}
              </td>
              <td className="px-3 py-2">{post.type}</td>
              <td className="px-3 py-2">{post.experience}</td>
              <td className="px-3 py-2">{post.skills}</td>
              <td className="px-3 py-2">{post.qualification}</td>
              <td className="px-3 py-2">{post.location}</td>
              <td className="px-3 py-2 flex flex-col md:flex-row gap-2">
                <button
                  className="bg-gray-600 px-4 py-2 text-white rounded-xl duration-300 hover:bg-[#919191]"
                  onClick={() => openModal(post.id)}
                >
                  Edit/View More
                </button>
                <button
                  className="bg-red-500 px-4 py-2 text-white rounded-xl duration-300 hover:bg-red-400"
                  onClick={() => deletePost(post.id)}
                >
                  Delete
                </button>
              </td>
              <Modal isOpen={modal && selectedId === post.id} onClose={onClose} id={selectedId} />
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CareerOption;
